import { all } from 'redux-saga/effects';
import authSaga from '~/reduxs/Auth/authSaga';

export default function* rootSaga() {
	yield all([
		authSaga()
	]);
}